import { Button, DatePicker } from "antd";
import { CalendarDays, ChartLine, List } from "lucide-react";
import { PlusOutlined } from "@ant-design/icons";
import PageHeader from "../../common/page-header/page-header";
import React from "react";
import { Dayjs } from "dayjs";
import { Segmented } from "antd/lib";


interface HolidayPageHeaderProps {
    selectedDate: Dayjs;
    onSelectedDateChange: (value: Dayjs) => void;
    view: 'list' | 'calendar' | 'stats';
    setView: (d: 'list' | 'calendar' | 'stats') => void;
    handleModalOpen: () => void;
    isAdmin: boolean;
}

function HolidayPageHeader(props: HolidayPageHeaderProps) {
    return (
        <PageHeader
            title={"Holiday Management"}
            description={"Browse, plan, and maintain holidays for your organisation"}
            actions={
                <>
                    <DatePicker
                        picker="year"
                        value={props.selectedDate}
                        allowClear={false}
                        className="pn-holiday__year-picker"
                        onChange={(value) => value && props.onSelectedDateChange(props.selectedDate.year(value.year()))}
                    />

                    <Segmented
                        className={'pn-holiday__view-toggle'}
                        options={[
                            {label: 'List', value: 'list', icon: <List size={14}/>},
                            {label: 'Calendar', value: 'calendar', icon: <CalendarDays size={14}/>},
                            {label: 'Stats', value: 'stats', icon: <ChartLine size={14}/>},
                        ]}
                        value={props.view}
                        onChange={(val: 'list' | 'calendar' | 'stats') => props.setView(val)}
                    />

                    {props.isAdmin &&
                    <Button
                        type={'primary'}
                        onClick={() => props.handleModalOpen()}
                        className={'pn-holiday__add-btn'}
                    >
                        <PlusOutlined/> Add Holiday
                    </Button>}
                </>
            }
        />
    )
}

export default HolidayPageHeader;
